import { Input } from 'antd';
import { TextAreaProps } from 'antd/es/input';
import classNames from 'classnames';
import React, { FC, useEffect, useState } from 'react';
import { TaskType } from 'api/tasks';
import { ClassNamePropsWithChildren } from 'components/ozone-component';
import styles from './task-name-input.module.css';

const { TextArea } = Input;

interface TaskNameInputProps extends ClassNamePropsWithChildren {
  taskType?: TaskType;
  inputProps?: TextAreaProps;
  value?: string;
  onPressEnter?: (
    value: string,
    e: React.KeyboardEvent<HTMLTextAreaElement>,
  ) => void;
}

export const TaskNameInput: FC<TaskNameInputProps> = (props) => {
  const { className, value, onPressEnter, inputProps } = props;

  const [state, setState] = useState(value);

  useEffect(() => {
    setState(value);

    return () => {
      setState('');
    };
  }, [value]);

  const handleOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setState(e.currentTarget.value);
  };

  const handleOnEnter = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    if (onPressEnter) {
      onPressEnter(e.currentTarget.value, e);
    }
  };

  return (
    <div className={classNames(styles.wrapper, className)}>
      {/* eslint-disable react/jsx-props-no-spreading */}
      <TextArea
        data-cy="task-drawer.task-name"
        value={state}
        onPressEnter={handleOnEnter}
        onChange={handleOnChange}
        autoSize={{ minRows: 1, maxRows: 2 }}
        {...inputProps}
        className={classNames(styles.input, inputProps?.className)}
      />
      {/* eslint-enable react/jsx-props-no-spreading */}
    </div>
  );
};
